import { forwardRef } from 'react';

export const StarCircleColoredIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg ref={ref} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <circle cx="16" cy="16" r="16" fill="currentColor" />
        <path
          d="M21.1965 24.9516C21.2695 24.984 21.3475 25 21.425 25C21.5502 25 21.6749 24.9576 21.7766 24.8762C21.9408 24.7447 22.0177 24.5323 21.9765 24.326L20.8306 18.5857L24.8363 14.573C24.983 14.4261 25.0368 14.2105 24.9769 14.0113C24.9171 13.8127 24.7523 13.663 24.549 13.6223L18.8075 12.4718L16.5151 7.30536C16.3339 6.89821 15.6681 6.89821 15.4868 7.30536L13.1945 12.4718L7.45294 13.6223C7.24969 13.663 7.0849 13.8127 7.02502 14.0113C6.96514 14.2105 7.01898 14.4261 7.16565 14.573L11.1713 18.5857L10.0254 24.326C9.98423 24.5323 10.0611 24.7447 10.2254 24.8762C10.3891 25.0072 10.6132 25.0369 10.8055 24.9516L16.001 22.6385L21.1965 24.9516Z"
          fill="#FFE33D"
        />
      </svg>
    );
  },
);
